export default __webpack_public_path__ + "assets/save-mobile-component.5cefc1ae.svg";